import { render, staticRenderFns } from "./Opportunity-Setting.vue?vue&type=template&id=47897562"
import script from "./Opportunity-Setting.vue?vue&type=script&lang=js"
export * from "./Opportunity-Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports